'use client';

import React from 'react';

import { Typography } from '@mui/material';

import EditInAdminButton from '@/ui/components/EditInAdminButton';
import Icon from '@/ui/components/Icon';
import { ManualTitle as StyledManualTitle, ManualSidebarShow } from '@/ui/components/Manual/manual.styled';

export const ManualTitle = ({ title, iconClick, isTabOpen, guide, showSidebarShow, isLoading = false }) => {
  const [isHovered, setIsHovered] = React.useState(false);

  return isLoading ? (
    <div className="pulse" style={{ height: '51px' }} />
  ) : (
    <StyledManualTitle onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <Typography variant="h5" component="h1">
        <EditInAdminButton item={guide} visible={isHovered} />
        {title}
      </Typography>
      {iconClick && showSidebarShow && (
        <ManualSidebarShow onClick={iconClick} $isTabOpen={isTabOpen}>
          <Icon name="chevron-down" />
        </ManualSidebarShow>
      )}
    </StyledManualTitle>
  );
};

export default ManualTitle;
